import SignalRService from '../SignalRService';

let messageHandler = null;
let reconnectedHandler = null;

const ConnectWebSocketForGoalAdmin = (onMessage = () => {}, onStatus = () => {}) => {
  onStatus('connecting');

  // Callback para despachar todos los mensajes recibidos
  messageHandler = (envelope) => {
    onMessage(envelope);
  };

  // Callback para manejar la reconexión y actualizar el estado
  reconnectedHandler = () => {
    onStatus('connected');
  };

  SignalRService.on('message', messageHandler);
  SignalRService.on('reconnected', reconnectedHandler);

  SignalRService.connect({ tipo: 'goal:admin' })
    .then(() => {
      onStatus('connected');
    })
    .catch((err) => {
      console.error("[RunToGoalWS] Error al conectar a SignalR:", err);
      onStatus('error');
    });
};

const DisconnectWebSocketForGoalAdmin = () => {
  try {
    if (messageHandler) {
      SignalRService.off('message', messageHandler);
      messageHandler = null;
    }
    if (reconnectedHandler) {
      SignalRService.off('reconnected', reconnectedHandler);
      reconnectedHandler = null;
    }
    SignalRService.disconnect();
  } catch (err) {
    console.error("[RunToGoalWS] Error al desconectar de SignalR:", err);
  }
};

export { ConnectWebSocketForGoalAdmin, DisconnectWebSocketForGoalAdmin };